import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { BiChevronLeft } from "@react-icons/all-files/bi/BiChevronLeft"
import { BiChevronRight } from "@react-icons/all-files/bi/BiChevronRight"

const CarouselWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;

  @media screen and (max-width: 767px) {
    overflow: visible;
    position: relative;
  }
`

const BookSlide = styled.div`
  position: absolute;
  transition: all 0.7s ease;
  transform: ${({ offset }) => {
    const translateX = offset * 250
    // const rotate = offset === 0 ? 0 : offset * 5
    const scale =
      offset === 0 ? 1.1 : offset === 1 || offset === -1 ? 0.95 : 0.85
    return `translateX(${translateX}px) scale(${scale})`
    // return `translateX(${translateX}px) scale(${scale}) rotateY(${rotate}deg)`
  }};
  z-index: ${({ offset }) => (offset === 0 ? 3 : offset === 1 || offset === -1 ? 2 : 1)};
  cursor: pointer;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: ${({ offset }) =>
    offset === 0
      ? "0 15px 35px rgba(0,0,0,0.3)"
      : "0 10px 20px rgba(0,0,0,0.2)"};

  @media (max-width: 767px) {
    transform: ${({ offset }) => {
      const translateX = offset * 140
      const scale =
        offset === 0 ? 1.05 : offset === 1 || offset === -1 ? 0.9 : 0.8
      return `translateX(${translateX}px) scale(${scale})`
    }};
  }
`

const Button = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: white;
  color: #333;
  font-size: 2rem;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  z-index: 5;
  transition: background 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background: #f0f0f0;
  }

  ${({ left }) => (left ? "left: 7rem;" : "right: 7rem;")}

  @media (max-width: 767px) {
    width: 40px;
    height: 40px;

    ${({ left }) => (left ? "left: 2rem;" : "right: 2rem;")}
  }
`

const BookImage = styled(GatsbyImage)`
  width: 400px;
  height: 520px;
  border-radius: 10px;
  transition: all 0.4s ease;

   @media screen and (max-width: 1190px) {
    height: 486px;
  }

  @media (max-width: 767px) {
    width: 200px;
    height: 300px;
  }
`

export default function BookCarousel({ books }) {
  const [index, setIndex] = useState(0)

  const next = () => setIndex((prev) => (prev + 1) % books.length)
  const prev = () => setIndex((prev) => (prev - 1 + books.length) % books.length)

  useEffect(() => {
    const timer = setInterval(next, 5000000)
    return () => clearInterval(timer)
  }, [index])

  return (
    <CarouselWrapper>
      <Button left onClick={prev}>
        <BiChevronLeft color="#111" size={30} />
      </Button>

      {books.map((book, i) => {
        const total = books.length
        const offset =
          ((i - index + total + Math.floor(total / 2)) % total) -
          Math.floor(total / 2)

        // Only show 5 books (center ±2)
        if (Math.abs(offset) > 2) return null

        return (
          <BookSlide
            key={book.node.id}
            offset={offset}
            onClick={() => window.open(book.node.url, "_blank")}
          >
            <BookImage image={getImage(book.node.img)} alt={book.node.name} />
          </BookSlide>
        )
      })}

      <Button onClick={next}>
        <BiChevronRight color="#111" size={30} />
      </Button>
    </CarouselWrapper>
  )
}
